
import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";


export default function SearchModal() {
    const [searchText, setSearchText] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const offcanvasEl = document.getElementById("search");
        const handleShow = () => setSearchText("");

        offcanvasEl?.addEventListener("show.bs.offcanvas", handleShow);

        return () => {
            offcanvasEl?.removeEventListener("show.bs.offcanvas", handleShow);
        };
    }, []);

    const handleSubmit = (e) => {

        e.preventDefault();
        if (!searchText.trim()) return;

        // Offcanvas kapat
        const closeBtn = document.querySelector('#search .icon-close-popup');
        if (closeBtn) closeBtn.click();

        // Sayfayı yönlendir
        navigate(`/product-list?search=${encodeURIComponent(searchText.trim())}`);
    };

    return (
        <div className="offcanvas offcanvas-top offcanvas-search input-page" id="search">
            <div className="offcanvas-content">
                <div className="header">
                    <button
                        className="icon-close icon-close-popup"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="looking-for-wrap">
                                <div className="heading">What are you looking for?</div>
                                <form className="form-search" onSubmit={handleSubmit}>
                                    <fieldset className="text">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            name="text"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            required
                                            autoComplete="off"
                                        />
                                    </fieldset>
                                    <button className="" type="submit">
                                        <i className="icon icon-search"/>
                                    </button>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
